import React from 'react';
import {
  createColumnsForObjectData,
  SalvBanner,
  SalvBannerAccent,
  SalvBannerType,
  SalvTable,
} from '@salvapp/ui-components';
import { NonConformingEntry } from './helper';

interface Props {
  entries: NonConformingEntry[];
}

export const NonConformingBanner = ({ entries }: Props) => {
  if (entries.length === 0) {
    return null;
  }

  return (
    <SalvBanner
      type={SalvBannerType.WARNING}
      accent={SalvBannerAccent.LIGHT}
      message='This record contains data that does not match the current schema. Non-matching fields are shown as raw data below.'
      className='m-b-16'
    />
  );
};

export const NonConformingRawData = ({ entries }: Props) => {
  if (entries.length === 0) {
    return null;
  }

  const renderRawValue = (value: unknown): string => {
    if (value === null || value === undefined) {
      return '-';
    }
    if (typeof value === 'string') {
      return value;
    }
    return JSON.stringify(value);
  };

  const columns = createColumnsForObjectData<{ label: string; displayValue: string }>([
    { accessorKey: 'label', header: 'Attribute' },
    { accessorKey: 'displayValue', header: 'Value' },
  ]);

  const tableData = entries.map((entry) => ({
    label: entry.label,
    displayValue: renderRawValue(entry.value),
  }));

  return (
    <>
      <div className='field-title text-m m-b-8 m-t-16'>Attributes outside current schema</div>
      <SalvTable columns={columns} data={tableData} />
    </>
  );
};
